const DEFAULT_CAPACITIES = {
  smarttransit_bus: { seats: 27, standing: 8 },
  smarttransit_minibus: { seats: 17, standing: 0 }
}

function pluralize (count, singular, plural) {
  return count === 1 ? singular : plural
}

function getPassengerLoadOverride (transportationProfile) {
  const vehicle = transportationProfile && transportationProfile.metadata
    ? transportationProfile.metadata.vehicle
    : null
  const passengerLoad = vehicle ? vehicle.passengerLoad : null

  if (!passengerLoad && passengerLoad !== 0) {
    return null
  }

  const load = Number(passengerLoad)
  if (!load || Number.isNaN(load) || load <= 0) {
    return null
  }

  return load
}

function formatSplitAvailableSpotsLabel (availableSeats, availableStanding) {
  if (availableStanding > 0) {
    return availableSeats + ' ' + pluralize(availableSeats, 'seat', 'seats') +
      ', ' + availableStanding + ' standing'
  }

  return availableSeats + ' ' + pluralize(availableSeats, 'seat', 'seats')
}

function formatTotalAvailableSpotsLabel (availableTotal) {
  return availableTotal + ' ' + pluralize(availableTotal, 'spot', 'spots')
}

/**
 * Resolve approximate available spots for SmartTransit vehicle types.
 *
 * Capacity order:
 * 1. metadata.vehicle.passengerLoad override (total capacity) for smarttransit bus/minibus
 * 2. smarttransit_bus defaults: 27 seats + 8 standing
 * 3. smarttransit_minibus defaults: 17 seats
 * 4. unsupported for other vehicle types
 *
 * @param {{transportationProfile?: object, transportType?: string, passengerCount?: number|null}} params
 * @returns {null|{supported:false}|{supported:true, mode:'split'|'total', availableSeats?:number, availableStanding?:number, availableTotal?:number, label:string}}
 */
function resolveAvailableSpots ({ transportationProfile, transportType, passengerCount } = {}) {
  if (passengerCount === null || passengerCount === undefined || passengerCount === '') {
    return null
  }

  const count = Number(passengerCount)
  if (Number.isNaN(count) || count < 0) {
    return null
  }

  const resolvedType = transportType ||
    (transportationProfile && transportationProfile.transportType) ||
    null
  const defaults = resolvedType ? DEFAULT_CAPACITIES[resolvedType] : null

  if (!defaults) {
    return { supported: false }
  }

  const overrideLoad = getPassengerLoadOverride(transportationProfile)
  if (overrideLoad) {
    const availableTotal = Math.max(overrideLoad - count, 0)
    return {
      supported: true,
      mode: 'total',
      availableTotal,
      label: formatTotalAvailableSpotsLabel(availableTotal)
    }
  }

  const availableSeats = Math.max(defaults.seats - count, 0)
  const availableStanding = Math.max(defaults.standing - Math.max(count - defaults.seats, 0), 0)

  return {
    supported: true,
    mode: 'split',
    availableSeats,
    availableStanding,
    label: formatSplitAvailableSpotsLabel(availableSeats, availableStanding)
  }
}

module.exports = {
  DEFAULT_CAPACITIES,
  resolveAvailableSpots
}
